import getShipment from './shipment';

const getRetainerShipment = row => {
  const shipment = getShipment(row);
  if (!shipment || shipment.kind !== 'retainer') {
    return null;
  }

  return {
    ship_date: shipment.ship_date,
    shipping_method: shipment.shipping_method,
    expected_arrival_date: shipment.expected_arrival_date,
    tracking_number: shipment.tracking_number,
    courier: shipment.courier,
    assigned_to: shipment.assigned_to,
    completed: shipment.completed,
    shipping_label_printed: shipment.shipping_label_printed,
    patient_label_printed: shipment.patient_label_printed
  };
};

export default getRetainerShipment;
